/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./auth-frame.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./auth-frame.component";
import * as i3 from "../auth.service";
var styles_AuthFrameComponent = [i0.styles];
var RenderType_AuthFrameComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AuthFrameComponent, data: {} });
export { RenderType_AuthFrameComponent as RenderType_AuthFrameComponent };
export function View_AuthFrameComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "div", [["id", "frame-container"]], null, null, null, null, null))], null, null); }
export function View_AuthFrameComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-auth-frame", [], null, null, null, View_AuthFrameComponent_0, RenderType_AuthFrameComponent)), i1.ɵdid(1, 114688, null, 0, i2.AuthFrameComponent, [i3.AuthService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AuthFrameComponentNgFactory = i1.ɵccf("app-auth-frame", i2.AuthFrameComponent, View_AuthFrameComponent_Host_0, {}, {}, []);
export { AuthFrameComponentNgFactory as AuthFrameComponentNgFactory };
